import React, { FC, useEffect } from 'react'
import { useGetTools } from '@/client/hooks'
import * as S from './styles'
import { Icon } from '../Icon'
interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export const Pagination: FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers: number[] = []
  const maxPageNumbersToShow = 5
  const ellipsis = '...'
  const { data } = useGetTools('')
  let startPage = Math.max(1, currentPage - 2)
  let endPage = Math.min(totalPages, currentPage + 2)

  if (currentPage <= 3) {
    endPage = Math.min(totalPages, maxPageNumbersToShow)
  }

  if (currentPage >= totalPages - 2) {
    startPage = Math.max(1, totalPages - (maxPageNumbersToShow - 1))
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i)
  }

  const paginationItems: React.ReactNode[] = []

  useEffect(() => {}, [data])
  if (startPage > 1) {
    paginationItems.push(
      <button key={1} onClick={() => onPageChange(1)} className={currentPage === 1 ? 'active' : ''}>
        1
      </button>
    )
    if (startPage > 2) {
      paginationItems.push(<span key='start-ellipsis'>{ellipsis}</span>)
    }
  }

  pageNumbers.forEach((number) => {
    paginationItems.push(
      <button key={number} onClick={() => onPageChange(number)} className={currentPage === number ? 'active' : ''}>
        {number}
      </button>
    )
  })

  const getCmsFormField = (id, key, tools) => {
    const getCmsForm = tools.filter((e) => e['id'] === id)
    return getCmsForm[0][key]
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      paginationItems.push(<span key='end-ellipsis'>{ellipsis}</span>)
    }
    paginationItems.push(
      <button
        key={totalPages}
        onClick={() => onPageChange(totalPages)}
        className={currentPage === totalPages ? 'active' : ''}
      >
        {totalPages}
      </button>
    )
  }

  return (
    <S.Pagination>
      <div className='pagination'>
        <button className='action-button' onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
          <Icon name='arrow-left' size='s4' />
          &nbsp;{data && data['tools'] && getCmsFormField('prev', 'title', data['tools'])}
        </button>
        <S.PaginationItem>{paginationItems}</S.PaginationItem>

        <button
          className='action-button'
          onClick={() => onPageChange(currentPage + 1)}
          disabled={endPage === currentPage}
        >
          {data && data['tools'] && getCmsFormField('next', 'title', data['tools'])} &nbsp;
          <Icon name='arrow-right' size='s4' />
        </button>
      </div>
    </S.Pagination>
  )
}
